// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lmJM","rootMobile":"styles_rootMobile__3aHcR"};